













import { Component, Prop, Vue } from 'vue-property-decorator';
import IconFlagDE from '@/assets/icons/flag-de.svg';
import IconFlagEN from '@/assets/icons/flag-en.svg';
import IconFlagES from '@/assets/icons/flag-es.svg';
import IconFlagFR from '@/assets/icons/flag-fr.svg';
import IconFlagIT from '@/assets/icons/flag-it.svg';
import IconFlagDK from '@/assets/icons/flag-dk.svg';
import IconFlagNL from '@/assets/icons/flag-nl.svg';
import IconFlagCZ from '@/assets/icons/flag-cz.svg';

@Component({
  components: { IconFlagDE, IconFlagEN, IconFlagES, IconFlagFR, IconFlagIT, IconFlagDK, IconFlagNL, IconFlagCZ },
})
export default class CountryFlag extends Vue {
  @Prop(String)
  public lang!: string;
}
